import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = (props, ref) => /* @__PURE__ */ React.createElement("svg", { id: "menu-alt", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: "icon line", width: 48, height: 48, ref, ...props }, /* @__PURE__ */ React.createElement("path", { id: "primary", d: "M3,18H21M3,12H21M3,6H21", style: {
  fill: "none",
  stroke: "rgb(255,255,255)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
} }));
const ForwardRef = forwardRef(SvgMenu);
export { ForwardRef as ReactComponent };
